import { FIELDS } from '@/pages/Company/components/CompanyDetails/constants';

const vendorFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    field: FIELDS.COMPANY_NAME,
    title: 'Company',
    sortable: true,
  },
  {

    field: FIELDS.FULL_NAME,
    title: 'Contact',
    sortable: true,
  },
  {

    field: FIELDS.VENDOR_TYPE,
    title: 'Vendor Type',
    sortable: true,
  },
  {
    field: FIELDS.COMPANY_RATING,
    title: 'Rating',
    cell: 'formatRatingAsWord',
    sortable: true,
  },
  {
    field: FIELDS.PHONE1,
    title: 'Phone',
    sortable: true,
  },
  {
    field: FIELDS.EMAIL1,
    title: 'Email',
    sortable: true,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  /*{
    field: FIELDS.VENDOR_TYPE,
    title: 'Vendor Type',
    sortable: true,
  },
  {
    field: FIELDS.VENDOR_ATTRIBUTE,
    title: 'Attribute',
    sortable: true,
  },*/
];

export default vendorFields;
